// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gk_qE","selected":"styles_selected__8_2Kt"};